import { schema, normalize } from 'normalizr';
import * as cruducer from 'helpers/cruducer';
import defineTypes from 'helpers/defineTypes';
import * as api from 'api/marketerSessions';

// Action Types
const Types = defineTypes('mt/marketerSessions', [
  'FETCH',
  'FETCHED',
  'FETCH_FAILED',
]);

// Schema
const marketerSessionSchema = new schema.Entity('marketerSessions');

// Reducer
const initialState = { byId: {}, ids: [], isFetching: false };
export default (state = initialState, action) => {
  switch (action.type) {
    case Types.FETCH:
      return cruducer.fetch(state);
    case Types.FETCHED: {
      const { entities, result } = action.payload;
      return cruducer.fetched(state, entities.marketerSessions, result);
    }
    default:
      return state;
  }
};

// Action Types
export const fetch = () => async dispatch => {
  dispatch({ type: Types.FETCH });
  try {
    const json = await api.fetch();
    const { entities, result } = normalize(json, [marketerSessionSchema]);
    dispatch({ type: Types.FETCHED, payload: { entities, result } });
  } catch (error) {
    dispatch({ type: Types.FETCH_FAILED, payload: { error } });
    throw error;
  }
};

// Selectors
export const getMarketerSession = (state, id) =>
  state.marketerSessions.byId[id];

export const getMarketerSessions = state =>
  state.marketerSessions.ids.map(id => state.marketerSessions.byId[id]);



// WEBPACK FOOTER //
// ./src/ducks/marketerSessions.js